const Cinema = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3699 17.3794C15.1704 14.9156 13.8245 12.2735 11.3603 11.4729C8.89664 10.6721 6.25445 12.0182 5.45375 14.4824C4.6532 16.9462 5.99906 19.5883 8.46328 20.3889C10.9159 21.186 13.5694 19.843 14.3699 17.3794ZM9.18758 18.16C7.95563 17.7596 7.2825 16.4388 7.68281 15.2067C8.08274 13.976 9.40297 13.3013 10.6361 13.7019C11.868 14.1021 12.5413 15.4231 12.1409 16.6552C11.7416 17.8843 10.4167 18.5593 9.18758 18.16Z"
        fill="currentColor"
      />
      <path
        d="M16.0727 22.6202C13.9768 21.0974 11.0481 21.5611 9.52521 23.6572C8.00247 25.753 8.46599 28.6818 10.5622 30.2047C12.6665 31.7334 15.6001 31.2455 17.1097 29.1677C18.6325 27.0718 18.1689 24.1431 16.0727 22.6202ZM15.2136 27.79C14.454 28.8355 12.9854 29.0681 11.9399 28.3085C10.8919 27.5471 10.66 26.0829 11.4214 25.0348C12.1826 23.9871 13.6471 23.7549 14.6951 24.5163C15.743 25.2777 15.975 26.742 15.2136 27.79Z"
        fill="currentColor"
      />
      <path
        d="M21.5832 22.6201C19.4873 24.1428 19.0233 27.0715 20.5462 29.1676C22.0612 31.2527 24.9969 31.728 27.0937 30.2047C29.1894 28.682 29.6537 25.7533 28.1307 23.6572C26.608 21.5613 23.6794 21.0972 21.5832 22.6201ZM25.7161 28.3086C24.6705 29.0683 23.2019 28.8356 22.4423 27.7901C21.6809 26.7422 21.9128 25.2778 22.9608 24.5163C24.0087 23.755 25.4731 23.9867 26.2346 25.0348C26.996 26.0828 26.7641 27.5471 25.7161 28.3086Z"
        fill="currentColor"
      />
      <path
        d="M23.286 17.3794C24.086 19.8413 26.7381 21.1866 29.1926 20.3889C31.6564 19.5883 33.0028 16.9465 32.2021 14.4823C31.4015 12.0184 28.7598 10.6722 26.2956 11.4728C23.8318 12.2733 22.4853 14.9151 23.286 17.3794ZM27.0199 13.7018C28.2521 13.3015 29.5728 13.9746 29.9732 15.2065C30.3734 16.4385 29.7005 17.7594 28.4684 18.1598C27.2392 18.559 25.9144 17.8841 25.5151 16.6551C25.1147 15.4232 25.7878 14.1022 27.0199 13.7018Z"
        fill="currentColor"
      />
      <path
        d="M18.8281 14.1406C21.4128 14.1406 23.5156 12.0378 23.5156 9.45312C23.5156 6.86844 21.4128 4.76562 18.8281 4.76562C16.2434 4.76562 14.1406 6.86844 14.1406 9.45312C14.1406 12.0378 16.2434 14.1406 18.8281 14.1406ZM18.8281 7.10938C20.1205 7.10938 21.1719 8.16078 21.1719 9.45312C21.1719 10.7455 20.1205 11.7969 18.8281 11.7969C17.5358 11.7969 16.4844 10.7455 16.4844 9.45312C16.4844 8.16078 17.5358 7.10938 18.8281 7.10938Z"
        fill="currentColor"
      />
      <path
        d="M18.8279 20C19.4751 20 19.9998 19.4753 19.9998 18.8281C19.9998 18.1809 19.4751 17.6562 18.8279 17.6562C18.1807 17.6562 17.656 18.1809 17.656 18.8281C17.656 19.4753 18.1807 20 18.8279 20Z"
        fill="currentColor"
      />
      <path
        d="M39.352 37.7796C36.1235 36.1654 32.4822 35.3122 28.8215 35.3122H27.8788C33.6567 32.1006 37.5778 25.9159 37.5778 18.828C37.5778 8.44618 29.1667 0 18.828 0C8.46337 0 0 8.46408 0 18.828C0 29.1927 8.46408 37.656 18.828 37.656H28.8215C32.1202 37.656 35.3991 38.4236 38.3038 39.876C38.884 40.1661 39.5872 39.9295 39.876 39.352C40.1654 38.7731 39.9308 38.0692 39.352 37.7796ZM2.34373 18.828C2.34373 9.73852 9.73852 2.34373 18.828 2.34373C27.8743 2.34373 35.2341 9.73852 35.2341 18.828C35.2341 27.9174 27.8743 35.3122 18.828 35.3122C9.7386 35.3122 2.34373 27.9174 2.34373 18.828Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Cinema;
